import http from "./httpService";
import auth from "./authService";

export function generateVisaReport(data) {
  return http.post(`/v1/reports/monthly/visa`, data);
}
export function generateYardReport(data) {
  return http.post(`/v1/reports/monthly/yard`, data);
}
export function generateVehicleReport(data) {
  return http.post(`/v1/reports/monthly/vehicle`, data);
}
export function generateRoomReport(data) {
  return http.post(`/v1/reports/monthly/room`, data);
}
